import config from "config";
import { ContentLayoutType5 } from "pages/Product/ContentLayouts/ContentLayoutType5";
import {
  AssetArea,
  DescriptionArea1,
  DescriptionArea2,
  DescriptionContent,
  DescriptionTitle,
  SectionSubTitle,
  SectionTitle,
  TitleArea,
  Video,
} from "pages/Product/ContentLayouts/styled";
import { FeatureSectionWrapper } from "pages/Product/FeaturesSection/styled";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const StyledFeatureSectionWrapper = styled(FeatureSectionWrapper)`
  padding: 100px 26px;
  margin: 0 auto;

  ${mediaMin.xs`
    padding: 30px 26px;
  `};

  ${mediaMin.md`
    padding: 90px 26px;
  `};

  ${mediaMin.lg`
    padding: 90px 0;
  `};
`;
export function Deliverable() {
  return (
    <StyledFeatureSectionWrapper id="deliverables">
      <ContentLayoutType5>
        <TitleArea>
          <SectionSubTitle>How can I manage</SectionSubTitle>
          <SectionTitle>Deliverables?</SectionTitle>
        </TitleArea>
        <AssetArea>
          <Video
            src={`${config.RESOURCE_ORIGIN}/videos/landing/product/feature-deliverable.mp4`}
            autoPlay
            muted
            loop
            playsInline
          />
        </AssetArea>
        <DescriptionArea1>
          <DescriptionTitle>Content Viewer</DescriptionTitle>
          <DescriptionContent>
            Clients can directly browse content with our content viewer and
            compare the changes.
          </DescriptionContent>
        </DescriptionArea1>
        <DescriptionArea2>
          <DescriptionTitle>Version Control Automated</DescriptionTitle>
          <DescriptionContent>
            All versions of files are organized with the activity history and
            downloadable.
          </DescriptionContent>
        </DescriptionArea2>
      </ContentLayoutType5>
    </StyledFeatureSectionWrapper>
  );
}
